export enum PortClassSI {
  UNSET_PORT_CLASS = 'UNSET_PORT_CLASS',
  INDIVIDUAL = 'INDIVIDUAL',
  CORPORATE = 'CORPORATE',
}
